import { Injectable } from '@angular/core';
import { User } from '@mitel/cloudlink-sdk';
import { mivoiceBusinessLicenses } from '../constants/constants';
import { AdminService } from './admin.service';
import { OrdersService } from './orders.service';
import { IntegCustomerAdminPortalService } from './integ-customer-admin-portal.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserMiVBSharedService {

  constructor(
    private adminService: AdminService,
    private ordersService: OrdersService, 
    private capIntegService: IntegCustomerAdminPortalService) { 
  }


  isMiVoiceBusinessLicenseAssignedToUser(user: User): Promise<any> {
    return this.ordersService.getUsersLicensesFromCachedList(user.userId).then( licenses => {
      // if there is a legit subscription license
      for ( var i = 0; i < licenses.length; i++ )
      {
        if(mivoiceBusinessLicenses.includes(licenses[i])){
          return licenses[i];
        }  
      }
      return undefined;
    });
  }

  /**
   * For a MiVB/MiCollab user created outside of Accounts app, they will be missing the mivb product tag until their 
   * User Details page is loaded and the tag is auto-added (method: setTagsForExistingUser)
   * It could be that an MiVB/MiCollab user was created externally, and their User Details page was never loaded.
   * In this case, they will not have the mivb product tag. If a delete is triggered for such a user, we must
   * still initiate the delete on the pbx.
   * @param user 
   * @returns 
   */
  doesUserHaveMiVoiceBusinessServiceWithCAP(user: User): Promise<any> {
    if (user.extension && user.pbxUserId) {
      return this.capIntegService.isCAPFeatureEnabled({accountId: user.accountId} as any);
    } else {
      return Promise.resolve(false);
    }
  }

  postLicenseChangeProcessing(user: User, emailWorthyChange: boolean ): Promise<any> {
    return new Promise(async (resolve, reject) => {
        if ( emailWorthyChange == false )
        {
          // No need to send the welcome email on change of MiVoice Business tier.
          resolve(true);
        } 
        else 
        {
          try 
          {
            if ( user.userVerified != true ) 
            {
              console.log("User is not verified, so we will send a welcome email for the new license for miteam meetings", user.userId);
              // send an email if user is not verified
              let emailBody = { "application": 'meetings' };
              await this.adminService.sendWelcomeEmailWithoutNotify(user.accountId, user.userId, emailBody);
  
            } 
            else 
            {
              // user was verified
              await this.adminService.sendMiteamMeetingOnlyWelcomeEmail(user);
            }
  
          } 
          catch (err) 
          {
            console.error("Failed to send the welcome email for the the Miteam meetings license", err);
          }
          resolve(true);
        }
		});
  }

  getRemainingLicenseDetails() {
 
    return this.ordersService.getRemainingLicenses(true).then( remainingLicenses => {
      let licenseInfo = {};
        for( let license in remainingLicenses) {
           if (mivoiceBusinessLicenses.includes(license)) {
            licenseInfo[license] = remainingLicenses[license];
          }
        }
        return licenseInfo;
      })
      .catch(error => {
        console.log("There was a problem fetching license information", error);
        return {};
      });
  }

  // for this first pass this is a very specific scenario
  // I created this shared method as it appears it will be tested a lot by different areas
  // VERY specifc scenario:
  //  - CAP is DISABLED
  //  - there is a MiVB subscription on the customer account
  canAddMiVBLicensesToUsers( user: User ): Promise<boolean>
  {
      // we need to determine if the CAP policy is OFF and there are MiVB licenses
      return this.capIntegService.isCAPFeatureEnabled({accountId: user.accountId} as any).then( enabled => {
        if ( enabled == true )
        {
          return false;  // CAP must be disabled
        }
        return this.ordersService.doesCustomerAccountHaveExistingProductSubsAndTier(
          environment.subscriptionIds.MiVoiceBusiness, ["MiVB_Premier",	"MiVB_Elite", "MiVB_Entry"]).then(existingSubs => {
            if ( existingSubs == true )
              return true;

            // OK CAP is off and there are no subs so can't assign licenses to users
            return false;
        });
      });
  }
}
